import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';

import {ScrollView} from 'react-native-gesture-handler';

import {
  useFocusEffect,
  useNavigation,
} from '@react-navigation/native';
import {NavigationKey} from '../../navigations/config';

import {StyleSheet} from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {RNEButton, RNEText} from '../../components';

import useStores from '../../stores/useStores';

import {useGetPendingConsultation} from '../../server/react-query/useConsultation';
import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';

import ConsultationListItemPending from '../consultation/ConsultationListItemPending';
import { width, height, totalSize } from 'react-native-dimension';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';
import {useMarkNotificationsReadByConsultationStatus} from '../../hooks/notification/useMarkNotificationsReadByConsultationStatus';

interface ConsultationPendingTabProps {
  searchKey?: string;
}

const ConsultationPendingTab = (props: ConsultationPendingTabProps) => {
  const navigation = useNavigation();

  const {patientProfileStore, recentlyViewedAccountsStore} = useStores();
  const activeProfile = patientProfileStore.activeProfileData;

  const {setCanRefresh} = usePullDownRefreshContext();
  useMarkNotificationsReadByConsultationStatus('pending');

  const {data, isLoading, refetch} = useGetPendingConsultation({
    status: [ConsultationStatusEnum.PENDING],
    subject: activeProfile?.patientId,
    SortBy: 'modifiedOn',
    Ascending: false,
    searchKey: props.searchKey,
  });

  const onItemPressed = (
    id: string,
    consultationData: ConsultationRequestResBody,
  ) => {
    recentlyViewedAccountsStore.addRecentlyViewedAccount(id, consultationData);
    (navigation as any).navigate(NavigationKey.CONSULTATION_DETAIL, {id});
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchKey]);

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };
  return (
    <ScrollView
      onScroll={handleScroll}
      onLayout={e => {
        setScrollViewHeight(e.nativeEvent.layout.height);
      }}
      onContentSizeChange={(contentWidth, contentHeight) => {
        setContentHeight(contentHeight);
      }}
      contentContainerStyle={[
        styles.scrollContainer,
        data && data.length === 0 && {justifyContent: 'center'},
      ]}>
      {isLoading && (
        <View style={styles.spinnerContainer}>
          <RNEButton
            height={32}
            loadingProps={loadingPropsStyle}
            loading={isLoading}
          />
        </View>
      )}

      
          {data &&
        data.map((item, index) => (
          <ConsultationListItemPending
            key={index}
            item={item}
            onPress={() => onItemPressed(item.serviceRequestId, item)}
          />
        ))}
         

      {data && data.length === 0 && (
        <View style={styles.placeholder}>
          <RNEText
            label={props.searchKey ? '' : 'No pending consultations'}
            color="grey"
            style={{fontSize: totalSize(1.8), fontFamily: 'Quicksand-Medium'}}
          />
        </View>
      )}
    </ScrollView>
  );
};

const loadingPropsStyle = {
  color: colorPalette.black,
};

const styles = StyleSheet.create({
  spinnerContainer: {
    marginTop: 16,
    width: '100%',
    justifyContent: 'flex-end',
  },
  scrollContainer: {
    flexGrow: 1, // allow ScrollView to take full height
  },
  placeholder: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ConsultationPendingTab;
